// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1WMpi","inputWrap":"CustomTip_inputWrap__1ea-C"};